// extracted by mini-css-extract-plugin
export default {"error":"c3oc4gbD6khXxl3byku_","textarea":"leDLdkbycNmkVSbXwaAi"};